import React, { type FormEventHandler, type PropsWithChildren } from 'react';
import type { FormErrors } from '@jwp/ott-common/types/form';

import FormFeedback from '../FormFeedback/FormFeedback';
import Button from '../Button/Button';

import styles from './FormLayout.module.scss';

type Props = PropsWithChildren<{
  title: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  onCancel?: () => void;
  submitting: boolean;
  errors: FormErrors<unknown>;
  submitLabel?: string;
  cancelLabel?: string;
}>;

const FormLayout = ({ title, errors, children, submitting, onSubmit, onCancel, submitLabel, cancelLabel }: Props) => {
  return (
    <form onSubmit={onSubmit}>
      <h2 className={styles.title}>{title}</h2>
      {errors.form && <FormFeedback variant="error">{errors.form}</FormFeedback>}
      {children}
      <div className={styles.actions}>
        {submitLabel && <Button type="submit" label={submitLabel} variant="contained" color="primary" disabled={submitting} fullWidth />}
        {cancelLabel && <Button type="button" label={cancelLabel} onClick={onCancel} disabled={submitting} fullWidth />}
      </div>
    </form>
  );
};

export default FormLayout;
